export default (node) => {
  /**
   * Data + elements
   */
  const tabButtonClassArray = [
    'bg-surface-invert',
    'text-text-invert',
    'bg-surface-secondary',
    'text-text-tertiary',
  ];

  const proMenuButton = node.querySelector('[data-pro-menu-button]');
  const readyToWearMenuButton = node.querySelector(
    '[data-ready-to-wear-menu-button]'
  );
  const proMenu = node.querySelector('[data-pro-menu]');
  const readyToWearMenu = node.querySelector('[data-ready-to-wear-menu]');
  const subMenuButtons = node.querySelectorAll('[data-sub-menu-button]');
  const subMenuCloseButtons = node.querySelectorAll('[data-menu-back-button]');
  const subMenu = node.querySelectorAll('[data-sub-menu]');

  /**
   * Functions
   */
  function toggleMenu(menu) {
    closeAllSubMenu();

    if (menu === 'pro' && proMenu.classList.contains('hidden')) {
      tabButtonClassArray.forEach((className) => {
        proMenuButton.classList.toggle(className);
        readyToWearMenuButton.classList.toggle(className);
      });
      proMenu.classList.toggle('hidden');
      readyToWearMenu.classList.toggle('hidden');
    }

    if (
      menu === 'readyToWear' &&
      readyToWearMenu.classList.contains('hidden')
    ) {
      tabButtonClassArray.forEach((className) => {
        proMenuButton.classList.toggle(className);
        readyToWearMenuButton.classList.toggle(className);
      });
      readyToWearMenu.classList.toggle('hidden');
      proMenu.classList.toggle('hidden');
    }
  }

  function openSubMenu({ dataset }) {
    const subMenu = node.querySelector(
      `[data-sub-menu="${dataset.linkedSubMenu}"]`
    );
    if (subMenu) {
      subMenu.style.transform = 'translateX(0)';
    }
  }

  function closeSubMenu({ dataset }) {
    const subMenu = node.querySelector(
      `[data-sub-menu="${dataset.linkedSubMenu}"]`
    );
    if (subMenu) {
      subMenu.style.transform = 'translateX(100%)';
    }
  }

  function closeAllSubMenu() {
    const subMenu = node.querySelectorAll(`[data-sub-menu]`);
    subMenu.forEach((subMenu) => {
      if (subMenu) {
        subMenu.style.transform = 'translateX(100%)';
      }
    });
  }

  /**
   * Init
   */
  const init = () => {
    proMenuButton.addEventListener('click', () => toggleMenu('pro'));
    readyToWearMenuButton.addEventListener('click', () =>
      toggleMenu('readyToWear')
    );
    subMenuButtons.forEach((button) => {
      button.addEventListener('click', () => openSubMenu(button));
    });
    subMenuCloseButtons.forEach((button) => {
      button.addEventListener('click', () => closeSubMenu(button));
    });
  };

  init();
};
